const LOCALHOST_IP_REGEX = /(^127\.)/;

const hostname = document.location.hostname;
const protocol = document.location.protocol;

const isLocalhost =
  'localhost' === hostname ||
  '::1' === hostname ||
  LOCALHOST_IP_REGEX.test(hostname);

export default () => !isLocalhost && 'https:' !== protocol;
